import { createFileRoute } from '@tanstack/react-router';

import { ListSelectionForm } from '@/features/risk-assessment/components/list-selection-form';

export const Route = createFileRoute('/_authenticated/risk-assessment/$id/list-selection')({
  component: ListSelectionPage,
});

function ListSelectionPage() {
  const { id } = Route.useParams();
  return <ListSelectionForm assessmentId={id} />;
}
